import { ISolResponse, IUpdateUser, IUpdateUserOID, IUserData, IUserDetailData } from "@/entities";
import { IPaged, IPageResponse } from "@/services";

export interface IUserService {
  getLoggedUser(): Promise<IUserDetailData | undefined>;

  getUsersPage(sort?: IUserRequest): Promise<IPageResponse<IUserData> | undefined>;

  saveUsersReport(sort?: IUsersReportRequest): Promise<void>;

  getUserDetail(idUser: number): Promise<IUserDetailData | undefined>;

  updateOIDSol(
    idUser: number | undefined,
    updateUser: IUpdateUserOID | undefined
  ): Promise<string | undefined>;

  updateUser(
    idUser: number | undefined,
    updateUser: IUpdateUser | undefined
  ): Promise<ISolResponse | undefined>;

  addUserServicepointApproval(
    idUser: number,
    updateUser: IUpdateUser
  ): Promise<boolean | undefined>;

  removeUserServicepoint(
    idUser: number,
    updateUser: IUpdateUser
  ): Promise<ISolResponse | undefined>;

  removeUserServicepointApprovals(
    idUser: number,
    updateUser: IUpdateUser
  ): Promise<boolean | undefined>;

  toggleAdmin(idUser: number): Promise<boolean | undefined>;

  toggleSupervisor(idUser: number): Promise<boolean | undefined>;

  toggleAprobador(idUser: number): Promise<boolean | undefined>;

  acceptDisclaimer(): Promise<void>;

  declineDisclaimer(): Promise<void>;

  syncUser(idUser: number): Promise<boolean | undefined>;
}

export enum EUserType {
  CLIENTE = "CLIENTE",
  PROSEGUR = "PROSEGUR",
}

export interface IUserRequest extends IPaged {
  active?: boolean;
  admin?: boolean;
  supervisor?: boolean;
  countryId?: number;
  creationDate?: string;
  email?: string;
  id?: number;
  lastname?: string;
  modificationDate?: string;
  name?: string;
  oid?: string;
  roles?: string[];
  username?: string;
  userType?: EUserType;
  client?: string;
  subClient?: string;
  servicePoint?: string;
  idUserPrecise?: boolean;
  namePrecise?: boolean;
  lastnamePrecise?: boolean;
  emailPrecise?: boolean;
  creationDatePrecise?: boolean;
  modificationDatePrecise?: boolean;
  clientPrecise?: boolean;
  subclientPrecise?: boolean;
  servicePointPrecise?: boolean;
  disclaimerAccepted?: boolean;
  nameOrLastname?: string;
  flowApproval?: boolean;
}

export interface IInformationOptions {
  includeUser?: boolean;
  includeFirstName?: boolean;
  includeLastName?: boolean;
  includeEmail?: boolean;
  includeCountry?: boolean;
  includeSupervisor?: boolean;
  includeAdministrator?: boolean;
  includeUserType?: boolean;
  includeClients?: boolean;
  includeSubClients?: boolean;
  includeServicePoints?: boolean;
  includeActiveStatus?: boolean;
  includeSolCreatedStatus?: boolean;
  includeSolSynchronizedStatus?: boolean;
  includeCreationDate?: boolean;
  includeModules?: boolean;
}

export interface IUsersReportRequest extends IPaged {
  filterOptions?: IUserRequest;
  informationOptions?: IInformationOptions;
}

export interface IUserServiceMock {
  getLoggedUser: jest.Mock<Promise<IUserDetailData | undefined>>;
  getUsersPage: jest.Mock<Promise<IPageResponse<IUserData> | undefined>>;
  saveUsersReport: jest.Mock<Promise<void>>;
  getUserDetail: jest.Mock<Promise<IUserDetailData | undefined>>;
  updateUser: jest.Mock<Promise<ISolResponse | undefined>>;
  addUserServicepointApproval: jest.Mock<Promise<boolean | undefined>>;
  removeUserServicepoint: jest.Mock<Promise<ISolResponse | undefined>>;
  removeUserServicepointApprovals: jest.Mock<Promise<boolean | undefined>>;
  toggleAdmin: jest.Mock<Promise<boolean | undefined>>;
  toggleSupervisor: jest.Mock<Promise<boolean | undefined>>;
  toggleAprobador: jest.Mock<Promise<boolean | undefined>>;
  acceptDisclaimer: jest.Mock<Promise<void>>;
  declineDisclaimer: jest.Mock<Promise<void>>;
  updateOIDSol: jest.Mock<Promise<string>>;
  syncUser: jest.Mock<Promise<boolean | undefined>>;
}
